<template>
    <div>
        <b-form @reset="onReset">
            <b-form-group
                id="input-group-name"
                :label="$t('digital_studies.your_name')"
                label-for="input-1">
                <b-form-input
                    id="input-1"
                    v-model="form.name"
                    required
                    :placeholder="$t('digital_studies.fill_in_your_name')"></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-group-email"
                label="E-mail:"
                label-for="input-1">
                <b-form-input
                    id="input-1"
                    v-model="form.email"
                    type="email"
                    required
                    :placeholder="$t('digital_studies.fill_in_your_email_address')"></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-group-remarks"
                label="Feedback:"
                label-for="input-1">
                <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    :placeholder="$t('digital_studies.fill_in_your_feedback')"
                    rows="10"
                    max-rows="15"></b-form-textarea>
            </b-form-group>

            <b-button
                type="button"
                variant="primary"
                @click="onSubmit"
                >{{ $t('digital_studies.sent') }}</b-button
            >
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'design-2021-digistudies-feedback-contact-form',
    props: {
        user: Object,
        userType: {
            type: String,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                description: '',
            },
        };
    },
    methods: {
        onSubmit() {
            const uri = 'help/feedback';

            this.alert.saving();

            this.axios.post(uri, this.form).then(
                (response) => {
                    this.onReset();
                    this.alert.success(this.$t('digital_studies.message_sent'));
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onReset(evt) {
            // Reset our form values
            this.form.description = '';
        },
    },
    created() {
        this.form.name = this.user.full_name;
        this.form.email = this.user.email;
    },
};
</script>
